'use es6';

import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { ChangeArrow } from 'foundations-components/transitional/components/ChangeArrow';
import { Link } from 'foundations-components/transitional/components/Link';
import { getReferenceLabel, getPropertyType } from 'reporting-data/v2/dataset/datasetRecords';
import { NUMERIC_PROPERTIES } from 'reporting-data/constants/numericProperties';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TableCell = ({
  point,
  valueProperty,
  statusProperty,
  differenceProperty,
  dataset,
  href,
  excludedStatuses = []
}) => {
  const value = point.get(valueProperty) || '-';
  const status = point.get(statusProperty);
  const difference = point.get(differenceProperty);
  const use = ['REGRESS', 'REMOVED', 'PUSH'].includes(status) ? 'removed' : 'success';
  let statusLabel = null;
  if (['INCREASE', 'DECREASE'].includes(status)) {
    statusLabel = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ChangeArrow, {
        use: status === 'DECREASE' ? 'decrease' : 'increase'
      }), getReferenceLabel(dataset, differenceProperty, difference)]
    });
  } else if (status && !['UNCHANGED', 'MISSING', ...excludedStatuses].includes(status)) {
    statusLabel = /*#__PURE__*/_jsx(StatusTag, {
      use: use,
      paddingInlineEnd: "0",
      children: getReferenceLabel(dataset, statusProperty, status)
    });
  }
  const valueLabel = href ? /*#__PURE__*/_jsx(Link, {
    href: href,
    target: "_blank",
    children: getReferenceLabel(dataset, valueProperty, value)
  }) : getReferenceLabel(dataset, valueProperty, value);
  return /*#__PURE__*/_jsxs("td", {
    className: NUMERIC_PROPERTIES.includes(getPropertyType(dataset, valueProperty)) ? 'text-right' : 'text-left',
    children: [valueLabel, /*#__PURE__*/_jsx("br", {}), statusLabel]
  });
};
export default TableCell;